import { render, staticRenderFns } from "./create-membershipDemand.vue?vue&type=template&id=2f30fe4e&scoped=true&"
import script from "./create-membershipDemand.vue?vue&type=script&lang=ts&"
export * from "./create-membershipDemand.vue?vue&type=script&lang=ts&"
import style0 from "./create-membershipDemand.vue?vue&type=style&index=0&id=2f30fe4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30fe4e",
  null
  
)

component.options.__file = "create-membershipDemand.vue"
export default component.exports